import "../../app/header/menu.css";
import React from "react";
import { ReactComponent as Logo } from "../../pages/login/images/logo.svg";

export function NomuraLogo() {
  return <Logo className="header-logo d-inline bg-white fill-red ml-2" style={{ width: 150, height: 50 }} />;
}
